// ** Custom Components
import NavGroup from "./NavGroup"
import NavBarLink from "./NavBarLink"
import { MenuKey, NavBarItemsProps } from "@pma/types"

const NavBarItems = ({ items, loadingGroupId, openMenu, onToggleMenu }: NavBarItemsProps) => {
  // Render a NavGroup only when its owning menu is the one currently open.
  // Untagged items (plain links, static groups) are always rendered.
  const visibleItems = items.filter((item) => !item.menuOf || item.menuOf === openMenu)

  const siblingPaths = visibleItems
    .filter((item) => item.children && item.path)
    .map((item) => item.path as string)

  return (
    <div className='space-y-1 p-4'>
      {visibleItems.map((item, idx) => {
        if (item.children) {
          return (
            <NavGroup
              key={idx}
              item={item}
              title={item.title}
              icon={item.icon}
              path={item.path}
              group_id={item.group_id}
              children={item.children}
              parent={true}
              loadingGroupId={loadingGroupId}
              siblingPaths={siblingPaths}
            />
          )
        }

        if (item.toggles) {
          return (
            <NavBarLink
              key={idx}
              item={item}
              title={item.title}
              icon={item.icon}
              path={item.path}
              onClick={() => onToggleMenu(item.toggles as MenuKey)}
              isActiveOverride={openMenu === item.toggles}
            />
          )
        }

        return (
          <NavBarLink
            key={idx}
            item={item}
            title={item.title}
            icon={item.icon}
            path={item.path}
            disabled={item.disabled}
            externalLink={item.externalLink}
            openInNewTab={item.openInNewTab}
          />
        )
      })}
    </div>
  )
}

export default NavBarItems
